import {useQuery} from "@tanstack/react-query";
import {useEffect, useRef} from "react";
import {isSessionAuthError} from "../Infra/http/sessionAuthError";
import {getUserDataService} from "../services/account/getUserData";
import {useAuthStore} from "../store/useAuth.store";

const useGetUserInfo = () => {
  const authStatus = useAuthStore(state => state.authStatus);
  const logout = useAuthStore(state => state.logout);
  const hasLoggedOutRef = useRef(false);

  const {data, isError, isLoading, isSuccess, refetch, error, isFetching} = useQuery({
    queryKey: ["userData"],
    queryFn: getUserDataService,
    staleTime: 5 * (60 * 1000), // 5 mins
    enabled: authStatus === "authenticated",
    retry: false,
  });

  useEffect(() => {
    if (authStatus !== "authenticated") {
      hasLoggedOutRef.current = false;
      return;
    }

    if (!isError || isFetching || !error) {
      return;
    }

    if (!isSessionAuthError(error)) {
      return;
    }

    if (hasLoggedOutRef.current) {
      return;
    }

    hasLoggedOutRef.current = true;
    logout();
  }, [authStatus, isError, isFetching, error, logout]);

  return {data: data?.data?.data, isError, isLoading, isSuccess, refetch, error};
};

export default useGetUserInfo;
